import isObject from "lodash/isObject"
import transform from "lodash/transform"
import isEqual from "react-fast-compare"
import { css } from "styled-components"
// import cloneDeep from "lodash/cloneDeep"

// Default file name length
export const MAX_NAME_LENGTH = 20

// n: string (filename, etc.)
// options: { isFile: boolean, len: number }
// returns string
// https://gist.github.com/solotimes/2537334
export const clampString = (n, options = {}) => {
  const { isFile = true, len = MAX_NAME_LENGTH } = options
  if (!isFile) {
    return n.length > len
      ? // ? n.substr(0, len - 4) + "..." + n.substr(len - 3, n.length)
        n.substr(0, len - 4) + "..."
      : n
  }

  const FINAL_LETTER_COUNT = 3
  const ext =
    n.lastIndexOf(".") !== -1
      ? n.substring(n.lastIndexOf(".") + 1, n.length).toLowerCase()
      : ""
  let filename = n.replace("." + ext, "")

  if (filename.length <= len) return n

  const returned =
    filename.substr(0, len - FINAL_LETTER_COUNT) +
    (n.length > len ? "[...]" : "") +
    filename.substr(filename.length - FINAL_LETTER_COUNT, filename.length - 1)

  return `${returned}${ext ? "." + ext : ""}`
}

export const isEnterKey = (event) =>
  event.key === "Enter" || event.code === "Enter" || event.keyCode === 13

const toDataURL = (url) =>
  window
    .fetch(url)
    .then((response) => {
      return response.blob()
    })
    .then((blob) => {
      return URL.createObjectURL(blob)
    })

export const download = async (filename, src) => {
  const element = document.createElement("a")
  // element.href = src
  element.href = await toDataURL(src)
  element.download = filename
  element.style.display = "none"

  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}

// https://stackoverflow.com/questions/3665115/how-to-create-a-file-in-memory-for-user-to-download-but-not-through-server
export const downloadTextAsFile = (filename, text) => {
  var element = document.createElement("a")
  element.setAttribute(
    "href",
    "data:text/plain;charset=utf-8," + encodeURIComponent(text)
  )
  element.setAttribute("download", filename)

  element.style.display = "none"
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}

export const objectDiff = (object, base) => {
  const changes = (object, base) => {
    return transform(object, function (result, value, key) {
      if (!isEqual(value, base[key])) {
        result[key] =
          isObject(value) &&
          isObject(base[key]) &&
          Object.keys(isObject(value)).length
            ? changes(value, base[key])
            : value
      }
    })
  }
  return changes(object, base)
}

export const breakPoints = {
  desktop: 992,
  tablet: 768,
  phone: 576
}

// Iterate through the sizes and create a media template
export const media = Object.keys(breakPoints).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${breakPoints[label] / 16}em) {
      ${css(...args)}
    }
  `

  return acc
}, {})

export const isMobile = (options) => {
  const device = options && options.device
  const width =
    options && options.device ? breakPoints[device] : breakPoints.tablet
  const windowContext = (options && options.browserWindow) || window

  if (windowContext.matchMedia) {
    return windowContext.matchMedia(
      `(max-width: ${width || breakPoints.tablet}px)`
    ).matches
  } else {
    return windowContext.innerWidth <= width || breakPoints.tablet
  }
}

export const isIPhone = () => {
  return !!window.navigator.platform && /iPhone/.test(window.navigator.platform)
}

export const isFirefox = () => {
  return (
    !!window.navigator &&
    window.navigator.userAgent &&
    /Firefox/.test(window.navigator.userAgent)
  )
}

// https://ourcodeworld.com/articles/read/376/how-to-strip-html-from-a-string-extract-only-text-content-in-javascript
export const removeHTML = (html) => {
  // Create a new div element
  const tempDivElement = window.document.createElement("div")
  // Set the HTML content with the providen
  tempDivElement.innerHTML = html
  // Retrieve the text property of the element (cross-browser support)
  return tempDivElement.textContent || tempDivElement.innerText || ""
}

// Quill adds wrapper markup
export const isEmptyHTML = (html) => {
  return (
    !html ||
    !html.length ||
    html === "<p><br></p>" ||
    html === "<p><br /></p>" ||
    html === "<p></p>"
  )
}
